<h1 mat-dialog-title>Filter</h1>

<div fxLayout="column" fxLayoutAlign="center start">
  <esc-campaign-distribution-selector 
    class="width-100" 
    [labelFlex]="20"
    [formWrapperFlex]="'auto'"
    [textLabel]="campaignDistributionSelectorLabel" 
    [wrapperLayoutAlign]="'start center'"
    [selectedCampaign]="selectedCampaign"
    [allocationLevel]="data?.allocationLevel"
    (campaignDistributionSelected)="campaignDistributionSelected($event)"
    ></esc-campaign-distribution-selector>
  
  <esc-web-user-selector 
    class="width-100" 
    [labelFlex]="20"
    [formWrapperFlex]="'auto'" 
    [textLabel]="webUserSelectorLabel" 
    [selectedWebUser]="selectedWebUser"
    [selectedCampaign]="selectedCampaign"
    [wrapperLayoutAlign]="'start center'"
    *ngIf="!isWebUserMultiSelect && data?.allocationLevel == 'two' && !helper.isUserMedrep()"
    (webUserSelected)="webUserSelected($event)"
    ></esc-web-user-selector>
  
  <esc-web-user-multi-selector 
    class="width-100" 
    [labelFlex]="20"
    [formWrapperFlex]="'auto'" 
    [textLabel]="webUserSelectorLabel" 
    [selectedWebUser]="selectedWebUser"
    [selectedCampaign]="selectedCampaign"
    [wrapperLayoutAlign]="'start center'"
    *ngIf="isWebUserMultiSelect && data?.allocationLevel == 'two' && !helper.isUserMedrep()"
    (webUserSelected)="webUserSelected($event)"
    ></esc-web-user-multi-selector>

  <esc-group-selector 
    class="width-100" 
    [labelFlex]="20"
    [formWrapperFlex]="'auto'" 
    [textLabel]="groupSelectorLabel" 
    [selectedGroup]="selectedGroup"
    [wrapperLayoutAlign]="'start center'"
    [selectedWebUser]="selectedWebUser"
    [selectedCampaign]="selectedCampaign"
    [allocationLevel]="data?.allocationLevel"
    [isWebUserMultiSelect]="isWebUserMultiSelect"
    (groupSelected)="groupSelected($event)"
    ></esc-group-selector>
</div>

<div mat-dialog-actions *ngIf="!media.isActive('lt-md')">
  <span class="spacer"></span>
  <button type="button" color="primary" mat-button (click)="applyFilters()" [disabled]="disableApply()"> {{ (isDownload ? 'LABEL_DOWNLOAD' : 'LABEL_APPLY') | translate }} </button>
  <button type="button" color="warn" mat-button (click)="reset()"> {{ 'LABEL_RESET' | translate }} </button>
  <button type="button" mat-button mat-dialog-close> {{ 'LABEL_CANCEL' | translate }} </button>
</div>

<!-- buttons for mobile view -->
<div mat-dialog-actions *ngIf="media.isActive('lt-md')">
  <span class="spacer"></span>

  <button type="button" color="primary" mat-icon-button (click)="applyFilters()" [disabled]="disableApply()">
    <mat-icon svgIcon="check"></mat-icon>
  </button>

  <button type="button" color="warn" mat-icon-button (click)="reset()">
    <mat-icon svgIcon="restore"></mat-icon>
  </button>

  <button type="button" mat-icon-button mat-dialog-close>
    <mat-icon svgIcon="cancel"></mat-icon>
  </button>
</div>